// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"133":"14c69c89","213":"b9799f45","239":"83291cd5","455":"221f2998"}[chunkId] + ".chunk.js";
};